export default __webpack_public_path__ + "steinberg-cubase.3a6b1743.png";